export const N2P_EVENT_NAME = 'n2p_event'
export const EVENT_DISPATCHER = 'dialer'

export const DISPATCH_EVENTS = {
  BLOCK_NUMBER: 'block_number',
  CALL_LIST_UPDATE: 'call_list_update',
  DIALER_IS_CONNECTED: 'dialer_is_connected',
  CONFIG: {
    READY: 'ready',
    TOGGLE_MERGE_EXPANDED: 'toggle_merge_expanded',
  },
  SESSION: {
    OUTGOING: 'outgoing_call_created',
  },
}

export const LISTEN_EVENTS = {
  SESSION: {
    TERMINATE: 'terminate_call',
    ACTIVATE: 'activate_call',
    CREATE: 'create_call',
    MERGE: 'merge_calls',
    PARK: 'park_call',
    UNPARKED: 'unparked_call_elsewhere',
  },
  TRANSFER: {
    BLIND: 'transfer_call_blind',
    CONSULTATIVE: 'transfer_calls_consultative',
  },
  CONFIG: {
    SET_MODE: 'set_mode', // TODO move this into a single initialize event
    APPEND_OPTIONS: 'append_options',
    UPDATE_ACCESS_TOKEN: 'update_access_token',
    LOGOUT: 'logout',
    LOGIN: 'login',
  },
}
